var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EpbButton',{attrs:{"icon":"download","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('downloadButtonClick')}},scopedSlots:_vm._u([(_vm.tooltip)?{key:"popover",fn:function(){return [_c('UiTooltip',[_vm._v("\n      "+_vm._s(_vm.tooltip)+"\n    ")])]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }